(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/chart-editor/chart-editor.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/chart-editor/chart-editor.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form #ceForm=\"ngForm\" (ngSubmit)=\"onSubmit(ceForm)\">\r\n  <div class=\"form-group\">\r\n    <label for=\"courseNameInput\">Course Name</label>\r\n    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"courseNameInput\" placeholder=\"Math 123\" ngModel>\r\n  </div>\r\n  <div class=\"form-group\">\r\n    <label for=\"courseInfoInput\">Info</label>\r\n    <input name=\"info\" type=\"text\" class=\"form-control\" id=\"courseInfoInput\" placeholder=\"Basic Arithmetic Skills\"\r\n      ngModel>\r\n  </div>\r\n  <div class=\"form-group\">\r\n    <label for=\"courseUnitsInput\">Units</label>\r\n    <input name=\"units\" type=\"number\" class=\"form-control\" id=\"courseUnitsInput\" placeholder=\"2\" ngModel>\r\n  </div>\r\n  <div class=\"form-group\">\r\n    <label for=\"coursePartInput\">Part</label>\r\n    <input name=\"part\" type=\"text\" class=\"form-control\" id=\"coursePartInput\" placeholder=\"IV\" ngModel>\r\n  </div>\r\n\r\n  <select [(ngModel)]=\"selectedParents\" name=\"selectedParent\" multiple>\r\n    <option *ngFor=\"let c of school.courses\" [ngValue]=\"c\">{{c.name}}</option>\r\n  </select>\r\n\r\n  <button type=\"submit\">Save</button>\r\n\r\n</form>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/course-info/course-info.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/course-info/course-info.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<section class=\"wrapper\">\r\n  <ng-container *ngIf=\"course\">\r\n    <div class=\"course-heading\">\r\n      <h1 class=\"course-name\">{{course.name}}\r\n        <span class=\"course-units\" *ngIf=\"course.units\">{{course.units}} units</span>\r\n      </h1>\r\n      <h2 class=\"course-description\">{{course.additionalInfo}}\r\n        <span class=\"course-part\" *ngIf=\"course.part\">PART {{course.part}}</span>\r\n      </h2>\r\n    </div>\r\n\r\n    <div class=\"course-more-info\">\r\n      <div class=\"more-info-item\">\r\n        <span class=\"mi-title\">Grading Method:</span>\r\n        <span class=\"mi-desc\">\r\n          {{course.gradingMethod}}\r\n        </span>\r\n      </div>\r\n      <div class=\"more-info-item\">\r\n        <span class=\"mi-title\">Transfer:</span>\r\n        <span class=\"mi-desc\">\r\n          {{course.transfer}}\r\n        </span>\r\n      </div>\r\n      <div class=\"more-info-item\">\r\n        <span class=\"mi-title\">Conditions of Enrollment:</span>\r\n        <span class=\"mi-desc\">\r\n          {{course.conditionsOfEnroll}}\r\n        </span>\r\n      </div>\r\n      <div class=\"more-info-item\">\r\n        <span class=\"mi-title\">Note:</span>\r\n        <span class=\"mi-desc\">\r\n          {{course.note}}\r\n        </span>\r\n      </div>\r\n      <div class=\"more-info-item\">\r\n        <span class=\"mi-title\">Business calculus sequences:</span>\r\n        <span class=\"mi-desc\">\r\n          {{course.bizCalcSequence}}\r\n        </span>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"course-text\">\r\n      <p>\r\n        {{course.courseDescription}}\r\n<!--        Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel ex totam, perspiciatis modi deserunt odio. Lorem-->\r\n<!--        ipsum dolor sit amet consectetur adipisicing elit. Vel ex totam. Lorem ipsum dolor sit amet consectetur-->\r\n<!--        adipisicing elit-->\r\n      </p>\r\n    </div>\r\n\r\n\r\n\r\n    <div class=\"course-videos-info\" *ngIf=\"course?.videos\">\r\n      <h2 class=\"videos-heading-title\">Course Videos</h2>\r\n\r\n      <ul class=\"videos-list\">\r\n        <li class=\"video-li\" *ngFor=\"let video of course.videos\">\r\n          <div class=\"video-item\">\r\n            <a [href]=\"video.videoUrl\" target=\"_blank\" class=\"thumbnail-holder-href\">\r\n              <img alt=\"TODO:Add alt later\" [src]=\"video.thumbnailUrl\">\r\n            </a>\r\n            <div class=\"video-item-details\">\r\n              <p class=\"video-item-heading\">{{video.title}}</p>\r\n              <p class=\"video-item-description\">{{video.subTitle}}</p>\r\n            </div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <button class=\"btn-load-more\">Load more...</button>\r\n    </div>\r\n  </ng-container>\r\n</section>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container-fluid\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"page-wrapper\">\r\n    <div class=\"auth-bg\">\r\n        <div class=\"authentication-box\">\r\n            <div class=\"text-center\"><img src=\"assets/images/logo/vicki-logo.png\" alt=\"\"></div>\r\n            <div class=\"card mt-4\">\r\n                <div class=\"card-body\">\r\n                    <div class=\"text-center\">\r\n                        <h4>LOGIN</h4>\r\n                        <h6>Enter your Username and Password </h6>\r\n                    </div>\r\n                    <form class=\"theme-form\" [formGroup]=\"loginForm\" *ngIf=\"!newUser\">\r\n                        <div class=\"form-group\">\r\n                            <label class=\"col-form-label pt-0\">Email</label>\r\n                            <input class=\"form-control\" formControlName=\"email\" type=\"email\" required=\"\">\r\n                            <div *ngIf=\"loginForm.controls.email.touched && loginForm.controls.email.errors?.required\"\r\n                                class=\"text text-danger mt-1\">\r\n                                Email is required\r\n                            </div>\r\n                            <div *ngIf=\"loginForm.controls.email.touched && loginForm.controls.email.errors?.email\"\r\n                                class=\"text text-danger mt-1\">\r\n                                Invalid Email\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <label class=\"col-form-label\">Password</label>\r\n                            <input class=\"form-control\" type=\"password\" formControlName=\"password\" required=\"\">\r\n                            <div *ngIf=\"loginForm.controls.password.touched && loginForm.controls.password.errors?.required\"\r\n                                class=\"text text-danger mt-1\">\r\n                                Password is required\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"checkbox p-0\">\r\n                            <input id=\"checkbox1\" type=\"checkbox\">\r\n                            <label for=\"checkbox1\">Remember me</label>\r\n                        </div>\r\n                        <div class=\"form-group form-row mt-3 mb-0\">\r\n                            <button class=\"btn btn-primary btn-block btn-lg\"\r\n                                [class.loader--text]=\"authService.showLoader\"\r\n                                [disabled]=\"!loginForm.valid || authService.showLoader\" (click)=\"login(loginForm.value)\"\r\n                                type=\"submit\"><span>{{ authService.showLoader ? '' : 'Login' }}</span>\r\n                            </button>\r\n                        </div>\r\n                        <div class=\"login-divider\"></div>\r\n                        <div class=\"social mt-3\">\r\n                            <div class=\"form-group btn-showcase d-flex\">\r\n                                <button class=\"btn social-btn btn-fb d-inline-block\" (click)=\"loginFacebook()\">\r\n                                    <i class=\"fa fa-facebook\"></i>\r\n                                </button>\r\n                                <button class=\"btn social-btn btn-twitter d-inline-block\" (click)=\"loginTwitter()\">\r\n                                    <i class=\"fa fa-twitter\"></i>\r\n                                </button>\r\n                                <button class=\"btn social-btn btn-google d-inline-block\" (click)=\"loginGoogle()\">\r\n                                    <i class=\"fa fa-google\"></i>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/school-chart/school-chart.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/school-chart/school-chart.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-zoom-level [(zoomLevel)]=\"zoomLevel\" [min]=\"zoomMin\" [max]=\"zoomMax\"></app-zoom-level>\r\n<svg><g></g></svg>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schools/schools.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schools/schools.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-sm-3 text-300 bg-300 pt-4 hidden\">\r\n    <ul class=\"nav nav-tabs\" role=\"tablist\">\r\n\r\n      <li class=\"nav-item\" (click)=\"setTab(schoolsTab)\">\r\n        <a href=\"javascript:void(0)\" class=\"nav-link\" [class.active]=\"activeTab === schoolsTab\" role=\"tab\"\r\n          data-toggle=\"tab\">Schools</a>\r\n      </li>\r\n\r\n      <li class=\"nav-item\" (click)=\"setTab(schoolChartViewerTab)\">\r\n        <a href=\"javascript:void(0)\" class=\"nav-link\" [class.active]=\"activeTab === schoolChartViewerTab\" role=\"tab\"\r\n          data-toggle=\"tab\">View</a>\r\n      </li>\r\n\r\n      <li class=\"nav-item\" (click)=\"setTab(schoolChartEditorTab)\">\r\n        <a href=\"javascript:void(0)\" class=\"nav-link\" [class.active]=\"activeTab === schoolChartEditorTab\" role=\"tab\"\r\n          data-toggle=\"tab\">Edit</a>\r\n      </li>\r\n\r\n    </ul> <!-- Tab panes -->\r\n    <div class=\"tab-content\">\r\n\r\n      <div role=\"tabpanel\" class=\"tab-pane\" [class.active]=\"activeTab === schoolsTab\" #schoolsTab>\r\n        <ng-container *ngIf=\"schools$ | async as schools\">\r\n          <form action=\"#\">\r\n            <div class=\"form-group\">\r\n              <input type=\"text\" class=\"form-control\" id=\"exampleInputEmail1\" aria-describedby=\"emailHelp\"\r\n                placeholder=\"Type your school name\">\r\n              <i class=\"fas fa-search\"></i>\r\n            </div>\r\n          </form>\r\n          <!-- TODO: Add filter -->\r\n          <div class=\"mt-2 p-2\" *ngFor=\"let sc of schools\">\r\n            <a [routerLink]=\"['/schools', sc.name]\">{{sc.name}}</a>\r\n          </div>\r\n          <button *ngIf=\"schools.length === 0\" (click)=\"seedClick()\">Seed</button>\r\n        </ng-container>\r\n      </div>\r\n\r\n      <div role=\"tabpanel\" class=\"tab-pane main-chart\" [class.active]=\"activeTab === schoolChartViewerTab\"\r\n        #schoolChartViewerTab>\r\n        <ng-container *ngIf=\"selectedSchool$ | async as school\">\r\n          <h5 class=\"show-info\">Showing math chart for:</h5>\r\n          <div class=\"school-info\">\r\n            <h4 class=\"title school-name\">{{school.name}}</h4>\r\n            <p class=\"school-info-text\">Some text here</p>\r\n          </div>\r\n          <app-course-info [course]=\"selectedCourse\"></app-course-info>\r\n        </ng-container>\r\n      </div>\r\n\r\n      <div role=\"tabpanel\" class=\"tab-pane main-chart\" [class.active]=\"activeTab === schoolChartEditorTab\"\r\n        #schoolChartEditorTab>\r\n        <ng-container *ngIf=\"selectedSchool$ | async as school\">\r\n          <app-chart-editor [school]=\"school\"></app-chart-editor>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <div class=\"no-paddings-lr main-view\" [ngClass]=\"{ 'col-sm-9': isPanelOpened, 'col-sm-12': !isPanelOpened }\">\r\n    <ng-container *ngIf=\"selectedSchool$ | async as school\">\r\n      <div class=\"school-row hidden\">\r\n        <!-- TODO: Replace SRC later -->\r\n        <img class=\"school-logo\" alt=\"{{school.name}} logo\" src=\"assets/compton-logo.png\">\r\n        <div class=\"school-info\">\r\n          <h1 class=\"school-name\">{{school.name}}</h1>\r\n          <h2 class=\"school-description\">{{school.description}}</h2>\r\n        </div>\r\n      </div>\r\n      <app-school-chart [school]=\"school\" (onCourseSelected)=\"setSelectedCourse($event)\" [orientation]=\"chartOrientation\"></app-school-chart>\r\n      <button class=\"orientation-toggle\" (click)=\"toggleOrientation()\"><i class=\"ion-md-repeat\"></i></button>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"toggle-panel no-paddings-lr main-view\"\r\n    [ngClass]=\"{ 'col-sm-3': isPanelOpened, 'hidden': !isPanelOpened }\">\r\n    <img class=\"btn-toggle toggle-close\" src=\"assets/collapse-right-64.png\" alt=\"Close panel\" (click)=\"togglePanel()\"\r\n      *ngIf=\"isPanelOpened\">\r\n    <app-course-info [course]=\"selectedCourse\"></app-course-info>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/zoom-level/zoom-level.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/zoom-level/zoom-level.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<input [(ngModel)]=\"linearZoom\" type=\"range\" [min]=\"minLinear\" [max]=\"maxLinear\" class=\"slider\">");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components */ "./src/app/components/index.ts");




const routes = [
    { path: "auth/login", component: _components__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
    {
        path: "", component: _components__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"],
        children: [
            { path: "", redirectTo: "schools", pathMatch: "full", },
            { path: "schools", component: _components__WEBPACK_IMPORTED_MODULE_3__["SchoolsComponent"] },
            { path: "schools/:name", component: _components__WEBPACK_IMPORTED_MODULE_3__["SchoolsComponent"] },
        ],
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let AppComponent = class AppComponent {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.title = "mathtv-charts-ui";
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: "app-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire */ "./node_modules/@angular/fire/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/fire/firestore */ "./node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components */ "./src/app/components/index.ts");
/* harmony import */ var _guards__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./guards */ "./src/app/guards/index.ts");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./services */ "./src/app/services/index.ts");


















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_14__["AppComponent"],
            ..._components__WEBPACK_IMPORTED_MODULE_15__["COMPONENTS"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__["BrowserModule"],
            ngx_toastr__WEBPACK_IMPORTED_MODULE_11__["ToastrModule"].forRoot(),
            _angular_fire__WEBPACK_IMPORTED_MODULE_3__["AngularFireModule"].initializeApp(src_environments_environment__WEBPACK_IMPORTED_MODULE_12__["environment"].firebase),
            _angular_fire_auth__WEBPACK_IMPORTED_MODULE_4__["AngularFireAuthModule"],
            _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_5__["AngularFirestoreModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_13__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClientModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_8__["BrowserAnimationsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_6__["ReactiveFormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormsModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_9__["NgbModule"]
        ],
        providers: [
            ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__["CookieService"],
            ..._services__WEBPACK_IMPORTED_MODULE_17__["SERVICES"],
            ..._guards__WEBPACK_IMPORTED_MODULE_16__["GUARDS"],
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_14__["AppComponent"]],
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/chart-editor/chart-editor.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/components/chart-editor/chart-editor.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("label {\n  color: black;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9jaGFydC1lZGl0b3IvRDpcXFByb2plY3RzXFxtYXRoLWNoYXJ0cy9zcmNcXGFwcFxcY29tcG9uZW50c1xcY2hhcnQtZWRpdG9yXFxjaGFydC1lZGl0b3IuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvY2hhcnQtZWRpdG9yL2NoYXJ0LWVkaXRvci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2hhcnQtZWRpdG9yL2NoYXJ0LWVkaXRvci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbImxhYmVsIHtcclxuICBjb2xvcjogYmxhY2s7XHJcbn1cclxuIiwibGFiZWwge1xuICBjb2xvcjogYmxhY2s7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/chart-editor/chart-editor.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/chart-editor/chart-editor.component.ts ***!
  \*******************************************************************/
/*! exports provided: ChartEditorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChartEditorComponent", function() { return ChartEditorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services */ "./src/app/services/index.ts");



let ChartEditorComponent = class ChartEditorComponent {
    constructor(schoolsService) {
        this.schoolsService = schoolsService;
    }
    ngAfterViewInit() {
    }
    onSubmit(form) {
        console.log("Your form data : ", form.value);
    }
};
ChartEditorComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["SchoolsService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ChartEditorComponent.prototype, "school", void 0);
ChartEditorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-chart-editor",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./chart-editor.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/chart-editor/chart-editor.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./chart-editor.component.scss */ "./src/app/components/chart-editor/chart-editor.component.scss")).default]
    })
], ChartEditorComponent);



/***/ }),

/***/ "./src/app/components/chart-editor/index.ts":
/*!**************************************************!*\
  !*** ./src/app/components/chart-editor/index.ts ***!
  \**************************************************/
/*! exports provided: ChartEditorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _chart_editor_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./chart-editor.component */ "./src/app/components/chart-editor/chart-editor.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChartEditorComponent", function() { return _chart_editor_component__WEBPACK_IMPORTED_MODULE_1__["ChartEditorComponent"]; });





/***/ }),

/***/ "./src/app/components/course-info/course-info.component.scss":
/*!*******************************************************************!*\
  !*** ./src/app/components/course-info/course-info.component.scss ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  background-color: #F0F1F2;\n  height: 100%;\n  width: 100%;\n  padding: 50px 45px;\n  color: #707070;\n  overflow: auto;\n}\n\n.course-heading .course-name {\n  font-size: 42px;\n  line-height: 50px;\n}\n\n.course-heading .course-name .course-units {\n  font-size: 24px;\n  line-height: 29px;\n  white-space: nowrap;\n}\n\n.course-heading .course-description {\n  font-size: 24px;\n  line-height: 29px;\n}\n\n.course-heading .course-description .course-part {\n  white-space: nowrap;\n}\n\n.course-text {\n  font-size: 20px;\n  line-height: 24px;\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n.course-videos-info .videos-heading-title {\n  font-size: 34px;\n  line-height: 40px;\n}\n\n.course-videos-info ul.videos-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.course-videos-info ul.videos-list li.video-li {\n  padding: 5px;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item {\n  display: flex;\n  flex-direction: row;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item .thumbnail-holder-href {\n  display: flex;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item .thumbnail-holder-href img {\n  width: 60px;\n  height: 55px;\n  border-radius: 9px;\n  margin: auto;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item .video-item-details {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item .video-item-details .video-item-heading {\n  font-size: 24px;\n  line-height: 29px;\n  padding: 0;\n  margin: 0;\n}\n\n.course-videos-info ul.videos-list li.video-li .video-item .video-item-details .video-item-description {\n  font-size: 18px;\n  line-height: 22px;\n  padding: 0;\n  margin: 0;\n}\n\n.course-videos-info .btn-load-more {\n  color: #373464;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  font-size: 25px;\n  line-height: 30px;\n  margin-top: 30px;\n  border: none;\n  background-color: transparent;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/course-info/course-info.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/course-info/course-info.component.ts ***!
  \*****************************************************************/
/*! exports provided: CourseInfoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CourseInfoComponent", function() { return CourseInfoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CourseInfoComponent = class CourseInfoComponent {
    constructor() {
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CourseInfoComponent.prototype, "course", void 0);
CourseInfoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-course-info",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./course-info.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/course-info/course-info.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./course-info.component.scss */ "./src/app/components/course-info/course-info.component.scss")).default]
    })
], CourseInfoComponent);



/***/ }),

/***/ "./src/app/components/course-info/index.ts":
/*!*************************************************!*\
  !*** ./src/app/components/course-info/index.ts ***!
  \*************************************************/
/*! exports provided: CourseInfoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _course_info_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./course-info.component */ "./src/app/components/course-info/course-info.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CourseInfoComponent", function() { return _course_info_component__WEBPACK_IMPORTED_MODULE_1__["CourseInfoComponent"]; });





/***/ }),

/***/ "./src/app/components/home/home.component.scss":
/*!*****************************************************!*\
  !*** ./src/app/components/home/home.component.scss ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".main {\n  margin-top: 0;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9ob21lL0Q6XFxQcm9qZWN0c1xcbWF0aC1jaGFydHMvc3JjXFxhcHBcXGNvbXBvbmVudHNcXGhvbWVcXGhvbWUuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvaG9tZS9ob21lLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9ob21lL2hvbWUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWFpbiB7XHJcbiAgICBtYXJnaW4tdG9wOiAwO1xyXG59IiwiLm1haW4ge1xuICBtYXJnaW4tdG9wOiAwO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/components/home/home.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/home/home.component.ts ***!
  \***************************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services */ "./src/app/services/index.ts");



let HomeComponent = class HomeComponent {
    constructor(schoolsService) {
        this.schoolsService = schoolsService;
    }
    ngAfterViewInit() {
        this.schools = this.schoolsService.getAll();
        this.schools.subscribe();
    }
};
HomeComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_2__["SchoolsService"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-home",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/components/home/home.component.scss")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/components/home/index.ts":
/*!******************************************!*\
  !*** ./src/app/components/home/index.ts ***!
  \******************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _home_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./home.component */ "./src/app/components/home/home.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return _home_component__WEBPACK_IMPORTED_MODULE_1__["HomeComponent"]; });





/***/ }),

/***/ "./src/app/components/index.ts":
/*!*************************************!*\
  !*** ./src/app/components/index.ts ***!
  \*************************************/
/*! exports provided: COMPONENTS, ChartEditorComponent, CourseInfoComponent, HomeComponent, LoginComponent, SchoolChartComponent, SchoolsComponent, ZoomLevelComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPONENTS", function() { return COMPONENTS; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _chart_editor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./chart-editor */ "./src/app/components/chart-editor/index.ts");
/* harmony import */ var _course_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./course-info */ "./src/app/components/course-info/index.ts");
/* harmony import */ var _home__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./home */ "./src/app/components/home/index.ts");
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./login */ "./src/app/components/login/index.ts");
/* harmony import */ var _school_chart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./school-chart */ "./src/app/components/school-chart/index.ts");
/* harmony import */ var _schools__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./schools */ "./src/app/components/schools/index.ts");
/* harmony import */ var _zoom_level__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./zoom-level */ "./src/app/components/zoom-level/index.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChartEditorComponent", function() { return _chart_editor__WEBPACK_IMPORTED_MODULE_1__["ChartEditorComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CourseInfoComponent", function() { return _course_info__WEBPACK_IMPORTED_MODULE_2__["CourseInfoComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return _home__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return _login__WEBPACK_IMPORTED_MODULE_4__["LoginComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolChartComponent", function() { return _school_chart__WEBPACK_IMPORTED_MODULE_5__["SchoolChartComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolsComponent", function() { return _schools__WEBPACK_IMPORTED_MODULE_6__["SchoolsComponent"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomLevelComponent", function() { return _zoom_level__WEBPACK_IMPORTED_MODULE_7__["ZoomLevelComponent"]; });
















const COMPONENTS = [
    _schools__WEBPACK_IMPORTED_MODULE_6__["SchoolsComponent"],
    _school_chart__WEBPACK_IMPORTED_MODULE_5__["SchoolChartComponent"],
    _zoom_level__WEBPACK_IMPORTED_MODULE_7__["ZoomLevelComponent"],
    _login__WEBPACK_IMPORTED_MODULE_4__["LoginComponent"],
    _home__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"],
    _chart_editor__WEBPACK_IMPORTED_MODULE_1__["ChartEditorComponent"],
    _course_info__WEBPACK_IMPORTED_MODULE_2__["CourseInfoComponent"]
];


/***/ }),

/***/ "./src/app/components/login/index.ts":
/*!*******************************************!*\
  !*** ./src/app/components/login/index.ts ***!
  \*******************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _login_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./login.component */ "./src/app/components/login/login.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return _login_component__WEBPACK_IMPORTED_MODULE_1__["LoginComponent"]; });





/***/ }),

/***/ "./src/app/components/login/login.component.scss":
/*!*******************************************************!*\
  !*** ./src/app/components/login/login.component.scss ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".loader--text {\n  position: absolute;\n  top: 200%;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.loader--text:after {\n  content: \"Loading\";\n  font-weight: bold;\n  -webkit-animation-name: loading-text;\n          animation-name: loading-text;\n  -webkit-animation-duration: 3s;\n          animation-duration: 3s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n\n@-webkit-keyframes loader {\n  15% {\n    transform: translateX(0);\n  }\n  45% {\n    transform: translateX(230px);\n  }\n  65% {\n    transform: translateX(230px);\n  }\n  95% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes loader {\n  15% {\n    transform: translateX(0);\n  }\n  45% {\n    transform: translateX(230px);\n  }\n  65% {\n    transform: translateX(230px);\n  }\n  95% {\n    transform: translateX(0);\n  }\n}\n\n@-webkit-keyframes loading-text {\n  0% {\n    content: \"Loading\";\n  }\n  25% {\n    content: \"Loading.\";\n  }\n  50% {\n    content: \"Loading..\";\n  }\n  75% {\n    content: \"Loading...\";\n  }\n}\n\n@keyframes loading-text {\n  0% {\n    content: \"Loading\";\n  }\n  25% {\n    content: \"Loading.\";\n  }\n  50% {\n    content: \"Loading..\";\n  }\n  75% {\n    content: \"Loading...\";\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9sb2dpbi9EOlxcUHJvamVjdHNcXG1hdGgtY2hhcnRzL3NyY1xcYXBwXFxjb21wb25lbnRzXFxsb2dpblxcbG9naW4uY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxrQkFBQTtFQUNBLFNBQUE7RUFDQSxPQUFBO0VBQ0EsUUFBQTtFQUNBLFlBQUE7QUNDSjs7QURDRTtFQUNFLGtCQUFBO0VBQ0EsaUJBQUE7RUFDQSxvQ0FBQTtVQUFBLDRCQUFBO0VBQ0EsOEJBQUE7VUFBQSxzQkFBQTtFQUNBLDJDQUFBO1VBQUEsbUNBQUE7QUNFSjs7QURDRTtFQUNFO0lBQ0Usd0JBQUE7RUNFSjtFREFFO0lBQ0UsNEJBQUE7RUNFSjtFREFFO0lBQ0UsNEJBQUE7RUNFSjtFREFFO0lBQ0Usd0JBQUE7RUNFSjtBQUNGOztBRGRFO0VBQ0U7SUFDRSx3QkFBQTtFQ0VKO0VEQUU7SUFDRSw0QkFBQTtFQ0VKO0VEQUU7SUFDRSw0QkFBQTtFQ0VKO0VEQUU7SUFDRSx3QkFBQTtFQ0VKO0FBQ0Y7O0FEQUU7RUFDRTtJQUNFLGtCQUFBO0VDRUo7RURBRTtJQUNFLG1CQUFBO0VDRUo7RURBRTtJQUNFLG9CQUFBO0VDRUo7RURBRTtJQUNFLHFCQUFBO0VDRUo7QUFDRjs7QURkRTtFQUNFO0lBQ0Usa0JBQUE7RUNFSjtFREFFO0lBQ0UsbUJBQUE7RUNFSjtFREFFO0lBQ0Usb0JBQUE7RUNFSjtFREFFO0lBQ0UscUJBQUE7RUNFSjtBQUNGIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9sb2dpbi9sb2dpbi5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sb2FkZXItLXRleHQge1xyXG4gICAgcG9zaXRpb246IGFic29sdXRlO1xyXG4gICAgdG9wOiAyMDAlO1xyXG4gICAgbGVmdDogMDtcclxuICAgIHJpZ2h0OiAwO1xyXG4gICAgbWFyZ2luOiBhdXRvO1xyXG4gIH1cclxuICAubG9hZGVyLS10ZXh0OmFmdGVyIHtcclxuICAgIGNvbnRlbnQ6IFwiTG9hZGluZ1wiO1xyXG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XHJcbiAgICBhbmltYXRpb24tbmFtZTogbG9hZGluZy10ZXh0O1xyXG4gICAgYW5pbWF0aW9uLWR1cmF0aW9uOiAzcztcclxuICAgIGFuaW1hdGlvbi1pdGVyYXRpb24tY291bnQ6IGluZmluaXRlO1xyXG4gIH1cclxuICBcclxuICBAa2V5ZnJhbWVzIGxvYWRlciB7XHJcbiAgICAxNSUge1xyXG4gICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMCk7XHJcbiAgICB9XHJcbiAgICA0NSUge1xyXG4gICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMjMwcHgpO1xyXG4gICAgfVxyXG4gICAgNjUlIHtcclxuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDIzMHB4KTtcclxuICAgIH1cclxuICAgIDk1JSB7XHJcbiAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKTtcclxuICAgIH1cclxuICB9XHJcbiAgQGtleWZyYW1lcyBsb2FkaW5nLXRleHQge1xyXG4gICAgMCUge1xyXG4gICAgICBjb250ZW50OiBcIkxvYWRpbmdcIjtcclxuICAgIH1cclxuICAgIDI1JSB7XHJcbiAgICAgIGNvbnRlbnQ6IFwiTG9hZGluZy5cIjtcclxuICAgIH1cclxuICAgIDUwJSB7XHJcbiAgICAgIGNvbnRlbnQ6IFwiTG9hZGluZy4uXCI7XHJcbiAgICB9XHJcbiAgICA3NSUge1xyXG4gICAgICBjb250ZW50OiBcIkxvYWRpbmcuLi5cIjtcclxuICAgIH1cclxuICB9IiwiLmxvYWRlci0tdGV4dCB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAyMDAlO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgbWFyZ2luOiBhdXRvO1xufVxuXG4ubG9hZGVyLS10ZXh0OmFmdGVyIHtcbiAgY29udGVudDogXCJMb2FkaW5nXCI7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBhbmltYXRpb24tbmFtZTogbG9hZGluZy10ZXh0O1xuICBhbmltYXRpb24tZHVyYXRpb246IDNzO1xuICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcbn1cblxuQGtleWZyYW1lcyBsb2FkZXIge1xuICAxNSUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKTtcbiAgfVxuICA0NSUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgyMzBweCk7XG4gIH1cbiAgNjUlIHtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoMjMwcHgpO1xuICB9XG4gIDk1JSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApO1xuICB9XG59XG5Aa2V5ZnJhbWVzIGxvYWRpbmctdGV4dCB7XG4gIDAlIHtcbiAgICBjb250ZW50OiBcIkxvYWRpbmdcIjtcbiAgfVxuICAyNSUge1xuICAgIGNvbnRlbnQ6IFwiTG9hZGluZy5cIjtcbiAgfVxuICA1MCUge1xuICAgIGNvbnRlbnQ6IFwiTG9hZGluZy4uXCI7XG4gIH1cbiAgNzUlIHtcbiAgICBjb250ZW50OiBcIkxvYWRpbmcuLi5cIjtcbiAgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/components/login/login.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/components/login/login.component.ts ***!
  \*****************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services */ "./src/app/services/index.ts");






let LoginComponent = class LoginComponent {
    constructor(route, authService, afauth, fb, router) {
        this.route = route;
        this.authService = authService;
        this.afauth = afauth;
        this.fb = fb;
        this.router = router;
        this.newUser = false;
        this.formErrors = {
            email: "",
            password: "",
        };
        this.loginForm = fb.group({
            email: ["david@envisability.com", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].email]],
            password: ["O7oMCUXM9nGON9emZ89OTIvLh", _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
        });
    }
    ngOnInit() {
        if (this.authService.isLoggedIn) {
            this.authService.SignOut()
                .then(() => {
                console.log("Signout");
            })
                .catch(() => { });
        }
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
        console.log(`this.returnUrl = ${this.returnUrl}`);
    }
    // Login With Google
    loginGoogle() {
        this.authService.GoogleAuth()
            .then(() => this.continueLogin());
    }
    // Login With Twitter
    loginTwitter() {
        this.authService.signInTwitter()
            .then(() => this.continueLogin());
    }
    // Login With Facebook
    loginFacebook() {
        this.authService.signInFacebok()
            .then(() => this.continueLogin());
    }
    // Simple Login
    login() {
        this.authService.SignIn(this.loginForm.value["email"], this.loginForm.value["password"])
            .then(() => this.continueLogin());
    }
    continueLogin() {
        this.router.navigateByUrl(this.returnUrl);
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AuthService"] },
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__["AngularFireAuth"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-login",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.scss */ "./src/app/components/login/login.component.scss")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/components/school-chart/index.ts":
/*!**************************************************!*\
  !*** ./src/app/components/school-chart/index.ts ***!
  \**************************************************/
/*! exports provided: SchoolChartComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _school_chart_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./school-chart.component */ "./src/app/components/school-chart/school-chart.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolChartComponent", function() { return _school_chart_component__WEBPACK_IMPORTED_MODULE_1__["SchoolChartComponent"]; });





/***/ }),

/***/ "./src/app/components/school-chart/school-chart.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/components/school-chart/school-chart.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host {\n  display: block;\n  height: 100vh;\n}\n:host svg {\n  height: 100%;\n  min-height: 100%;\n  width: 100%;\n}\n:host app-zoom-level {\n  position: absolute;\n  bottom: 0;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9zY2hvb2wtY2hhcnQvRDpcXFByb2plY3RzXFxtYXRoLWNoYXJ0cy9zcmNcXGFwcFxcY29tcG9uZW50c1xcc2Nob29sLWNoYXJ0XFxzY2hvb2wtY2hhcnQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvc2Nob29sLWNoYXJ0L3NjaG9vbC1jaGFydC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGNBQUE7RUFDQSxhQUFBO0FDQ0Y7QURDRTtFQUNFLFlBQUE7RUFDQSxnQkFBQTtFQUNBLFdBQUE7QUNDSjtBREVFO0VBQ0Usa0JBQUE7RUFDQSxTQUFBO0FDQUoiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3NjaG9vbC1jaGFydC9zY2hvb2wtY2hhcnQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XHJcbiAgZGlzcGxheTogYmxvY2s7XHJcbiAgaGVpZ2h0OiAxMDB2aDtcclxuXHJcbiAgc3ZnIHtcclxuICAgIGhlaWdodDogMTAwJTtcclxuICAgIG1pbi1oZWlnaHQ6IDEwMCU7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcblxyXG4gIGFwcC16b29tLWxldmVsIHtcclxuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICAgIGJvdHRvbTogMDtcclxuICB9XHJcbn1cclxuXHJcbiIsIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwdmg7XG59XG46aG9zdCBzdmcge1xuICBoZWlnaHQ6IDEwMCU7XG4gIG1pbi1oZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuOmhvc3QgYXBwLXpvb20tbGV2ZWwge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGJvdHRvbTogMDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/school-chart/school-chart.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/school-chart/school-chart.component.ts ***!
  \*******************************************************************/
/*! exports provided: SchoolChartComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchoolChartComponent", function() { return SchoolChartComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var d3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! d3 */ "./node_modules/d3/index.js");
/* harmony import */ var dagre_d3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! dagre-d3 */ "./node_modules/dagre-d3/index.js");
/* harmony import */ var dagre_d3__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dagre_d3__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/services */ "./src/app/services/index.ts");






const ORIENTATION = { horizontal: "LR", vertical: "TB" };
let SchoolChartComponent = class SchoolChartComponent {
    constructor(schoolsService, elRef) {
        this.schoolsService = schoolsService;
        this.elRef = elRef;
        this.zoomMin = 0.1;
        this.zoomMax = 10;
        this.onCourseSelected = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    set orientation(value) {
        this._orientation = value || "horizontal";
        if (this.graph) {
            this.zoomLevel = 1;
            this.update();
            // reset zoom and translate due to the issue with nodes position calculation
            // not considering the current scale
            this.zoom.translateTo(this.svg, 0, 0, [0, 0]);
        }
    }
    get zoomLevel() {
        return this._zoomLevel;
    }
    set zoomLevel(value) {
        if (this.zoomLevel === value) {
            return;
        }
        this._zoomLevel = value;
        this.zoom.scaleTo(this.svg, value);
    }
    onNodeClick(event) {
        const el = event.target;
        const node = el.closest(".node");
        if (this.elRef.nativeElement.contains(el) && node) {
            this.onCourseSelected.next(lodash__WEBPACK_IMPORTED_MODULE_4___default.a.find(this.school.courses, { id: +node.__data__ }));
        }
    }
    ngAfterViewInit() {
        this.graph = new dagre_d3__WEBPACK_IMPORTED_MODULE_3___default.a.graphlib.Graph().setGraph({});
        lodash__WEBPACK_IMPORTED_MODULE_4___default.a.each(this.school.courses, (course) => {
            this.graph.setNode(course.id);
        });
        lodash__WEBPACK_IMPORTED_MODULE_4___default.a.each(this.school.coursesLinks, (link) => {
            this.graph.setEdge(link.parentId, link.childId, { label: " " });
        });
        this.svg = d3__WEBPACK_IMPORTED_MODULE_2__["select"](this.elRef.nativeElement);
        this.zoom = d3__WEBPACK_IMPORTED_MODULE_2__["zoom"]().scaleExtent([this.zoomMin, this.zoomMax]).on("zoom", () => {
            this.svg.select("g").attr("transform", d3__WEBPACK_IMPORTED_MODULE_2__["event"].transform);
            this.zoomLevel = d3__WEBPACK_IMPORTED_MODULE_2__["event"].transform.k;
        });
        this.svg.call(this.zoom);
        // Create the renderer
        this.renderer = new dagre_d3__WEBPACK_IMPORTED_MODULE_3___default.a.render();
        this.update();
    }
    update() {
        const options = this.graph.graph();
        options.rankdir = ORIENTATION[this._orientation];
        options.ranksep = this._orientation === "horizontal" ? 200 : 100;
        // Set html for nodes
        lodash__WEBPACK_IMPORTED_MODULE_4___default.a.each(this.graph.nodes(), (id) => {
            const course = lodash__WEBPACK_IMPORTED_MODULE_4___default.a.find(this.school.courses, { id: +id });
            this.graph.setNode(id, {
                labelType: "html",
                label: this.courseTemplate(course),
                rx: 5,
                ry: 5,
                padding: 0,
            });
        });
        this.renderer(this.svg.select("g"), this.graph);
        this.svg.attr("height", this.graph.graph().height + 40);
    }
    courseTemplate(d) {
        return `<div class="course course-${d.id}">
      <div class="name">${d.name}</div>
      <div class="units">${d.units} units</div>
      <div class="info">${d.additionalInfo}</div>
      ${this.videosTemplate(d.videos)}
     </div>`;
    }
    videosTemplate(videos) {
        if (!videos)
            return "";
        return `<div class="videos">
      ${lodash__WEBPACK_IMPORTED_MODULE_4___default.a.map(videos, (video) => this.videoTemplate(video)).join("")}
    </div>`;
    }
    videoTemplate(video) {
        return `<a class="video" href="${video.videoUrl}"}>
      <i class="ion-md-play-circle"></i>
      <img src="${video.thumbnailUrl}"/>
    </a>`;
    }
};
SchoolChartComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_5__["SchoolsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SchoolChartComponent.prototype, "school", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SchoolChartComponent.prototype, "orientation", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], SchoolChartComponent.prototype, "onCourseSelected", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("document:click", ["$event"])
], SchoolChartComponent.prototype, "onNodeClick", null);
SchoolChartComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-school-chart",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./school-chart.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/school-chart/school-chart.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./school-chart.component.scss */ "./src/app/components/school-chart/school-chart.component.scss")).default]
    })
], SchoolChartComponent);



/***/ }),

/***/ "./src/app/components/schools/index.ts":
/*!*********************************************!*\
  !*** ./src/app/components/schools/index.ts ***!
  \*********************************************/
/*! exports provided: SchoolsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _schools_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./schools.component */ "./src/app/components/schools/schools.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolsComponent", function() { return _schools_component__WEBPACK_IMPORTED_MODULE_1__["SchoolsComponent"]; });





/***/ }),

/***/ "./src/app/components/schools/schools.component.scss":
/*!***********************************************************!*\
  !*** ./src/app/components/schools/schools.component.scss ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".main-chart {\n  height: 100vh;\n  padding: 20px 0;\n  color: #000;\n}\n\n.toggle-panel {\n  position: relative;\n}\n\n.toggle-panel .btn-toggle {\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  z-index: 5;\n  left: 5px;\n  width: 23px;\n  height: 28px;\n  cursor: pointer;\n}\n\n.main-view {\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n.main-view .orientation-toggle {\n  position: absolute;\n  bottom: 13px;\n  left: 148px;\n}\n\n.school-row {\n  display: flex;\n  flex-direction: row;\n  padding: 40px 50px;\n}\n\n.school-row img.school-logo {\n  width: auto;\n  height: 120px;\n}\n\n.school-row .school-info {\n  display: flex;\n  flex-direction: column;\n  margin-left: 15px;\n}\n\n.school-row .school-info .school-name {\n  font-size: 55px;\n  line-height: 66px;\n  padding: 0;\n  margin: 0;\n}\n\n.school-row .school-info .school-description {\n  font-size: 24px;\n  line-height: 29px;\n  padding: 0;\n  margin: 0;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schools/schools.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/schools/schools.component.ts ***!
  \*********************************************************/
/*! exports provided: SchoolsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchoolsComponent", function() { return SchoolsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/services */ "./src/app/services/index.ts");






let SchoolsComponent = class SchoolsComponent {
    constructor(schoolsService, route) {
        this.schoolsService = schoolsService;
        this.route = route;
        this.schoolName$ = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](null);
        this.isPanelOpened = false;
        this.chartOrientation = "horizontal";
    }
    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.schoolName$.next(params.get("name"));
        });
        this.schools$ = this.schoolsService.getAll();
        //
        this.selectedSchool$ = this.schools$.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])((schools) => {
            return schools ? schools[0] : null;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])((school) => {
            if (!school.defaultCourseId || !school.courses || school.courses.length === 0) {
                return;
            }
            this.selectedCourse = school.courses.find((course) => course.id === school.defaultCourseId);
            if (!this.selectedCourse) {
                console.warn(`Cannot find Course by defaultCourseId: ${school.defaultCourseId}`);
                return;
            }
            this.togglePanel(true);
        }));
        // TODO: Switch back later
        // this.selectedSchool$ = this.schoolName$.pipe(
        //   switchMap((name: string) => this.schools$.pipe(
        //     map((schools: ISchool[]) => {
        //       const found = schools.find((s) => s.name === name);
        //       return found;
        //     })
        //   )),
        // );
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.setTab(this.defaultTab.nativeElement);
        }, 0);
    }
    setTab(tab) {
        this.activeTab = tab || this.defaultTab.nativeElement;
    }
    setSelectedCourse(course) {
        this.selectedCourse = course;
        this.togglePanel(true);
    }
    seedClick() {
        this.schoolsService.createTestSchool()
            .catch((e) => console.error(e));
    }
    togglePanel(forceState) {
        if (forceState) {
            this.isPanelOpened = forceState;
        }
        else {
            this.isPanelOpened = !this.isPanelOpened;
        }
    }
    toggleOrientation() {
        this.chartOrientation = this.chartOrientation === "horizontal" ? "vertical" : "horizontal";
    }
};
SchoolsComponent.ctorParameters = () => [
    { type: src_app_services__WEBPACK_IMPORTED_MODULE_5__["SchoolsService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("schoolsTab", null)
], SchoolsComponent.prototype, "defaultTab", void 0);
SchoolsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-schools",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./schools.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schools/schools.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./schools.component.scss */ "./src/app/components/schools/schools.component.scss")).default]
    })
], SchoolsComponent);



/***/ }),

/***/ "./src/app/components/zoom-level/index.ts":
/*!************************************************!*\
  !*** ./src/app/components/zoom-level/index.ts ***!
  \************************************************/
/*! exports provided: ZoomLevelComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _zoom_level_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./zoom-level.component */ "./src/app/components/zoom-level/zoom-level.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomLevelComponent", function() { return _zoom_level_component__WEBPACK_IMPORTED_MODULE_1__["ZoomLevelComponent"]; });





/***/ }),

/***/ "./src/app/components/zoom-level/zoom-level.component.scss":
/*!*****************************************************************!*\
  !*** ./src/app/components/zoom-level/zoom-level.component.scss ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host {\n  padding: 10px;\n  background: white;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy96b29tLWxldmVsL0Q6XFxQcm9qZWN0c1xcbWF0aC1jaGFydHMvc3JjXFxhcHBcXGNvbXBvbmVudHNcXHpvb20tbGV2ZWxcXHpvb20tbGV2ZWwuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvem9vbS1sZXZlbC96b29tLWxldmVsLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLGlCQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3pvb20tbGV2ZWwvem9vbS1sZXZlbC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcclxuICBwYWRkaW5nOiAxMHB4O1xyXG4gIGJhY2tncm91bmQ6IHdoaXRlO1xyXG59XHJcbiIsIjpob3N0IHtcbiAgcGFkZGluZzogMTBweDtcbiAgYmFja2dyb3VuZDogd2hpdGU7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/zoom-level/zoom-level.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/zoom-level/zoom-level.component.ts ***!
  \***************************************************************/
/*! exports provided: ZoomLevelComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZoomLevelComponent", function() { return ZoomLevelComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var d3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! d3 */ "./node_modules/d3/index.js");



let ZoomLevelComponent = class ZoomLevelComponent {
    constructor() {
        this.min = 0.1;
        this.max = 10;
        this.zoomLevelChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.minLinear = 1;
        this.maxLinear = 100;
        this.scale = Object(d3__WEBPACK_IMPORTED_MODULE_2__["scaleLog"])()
            .base(Math.E)
            .domain([this.min, this.max])
            .range([this.minLinear, this.maxLinear]);
    }
    get zoomLevel() {
        return this._zoomLevel;
    }
    set zoomLevel(value) {
        if (value === this.zoomLevel) {
            return;
        }
        this._zoomLevel = value;
        this.zoomLevelChange.emit(this.zoomLevel);
    }
    get linearZoom() {
        return this.scale(this.zoomLevel);
    }
    set linearZoom(value) {
        this.zoomLevel = this.scale.invert(value);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ZoomLevelComponent.prototype, "min", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ZoomLevelComponent.prototype, "max", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ZoomLevelComponent.prototype, "zoomLevel", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], ZoomLevelComponent.prototype, "zoomLevelChange", void 0);
ZoomLevelComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-zoom-level",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./zoom-level.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/zoom-level/zoom-level.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./zoom-level.component.scss */ "./src/app/components/zoom-level/zoom-level.component.scss")).default]
    })
], ZoomLevelComponent);



/***/ }),

/***/ "./src/app/guards/admin.guard.ts":
/*!***************************************!*\
  !*** ./src/app/guards/admin.guard.ts ***!
  \***************************************/
/*! exports provided: AdminGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminGuard", function() { return AdminGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services */ "./src/app/services/index.ts");




let AdminGuard = class AdminGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(next, state) {
        // Guard for user is login or not
        let user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            this.router.navigate(["/auth/login"], { queryParams: { returnUrl: state.url } });
            return true;
        }
        return true;
    }
};
AdminGuard.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AdminGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], AdminGuard);



/***/ }),

/***/ "./src/app/guards/index.ts":
/*!*********************************!*\
  !*** ./src/app/guards/index.ts ***!
  \*********************************/
/*! exports provided: GUARDS, AdminGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GUARDS", function() { return GUARDS; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _admin_guard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./admin.guard */ "./src/app/guards/admin.guard.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdminGuard", function() { return _admin_guard__WEBPACK_IMPORTED_MODULE_1__["AdminGuard"]; });




const GUARDS = [
    _admin_guard__WEBPACK_IMPORTED_MODULE_1__["AdminGuard"],
];


/***/ }),

/***/ "./src/app/services/auth/auth.service.ts":
/*!***********************************************!*\
  !*** ./src/app/services/auth/auth.service.ts ***!
  \***********************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/firestore */ "./node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");








let AuthService = class AuthService {
    constructor(afs, afAuth, router, ngZone, toster, cookieService) {
        this.afs = afs;
        this.afAuth = afAuth;
        this.router = router;
        this.ngZone = ngZone;
        this.toster = toster;
        this.cookieService = cookieService;
        this.showLoader = false;
        this.afAuth.authState.subscribe((user) => {
            if (user) {
                this.userData = user;
                this._sessionId = this.userData;
                cookieService.set("user", JSON.stringify(this.userData));
                JSON.parse(cookieService.get("user"));
                localStorage.setItem("user", JSON.stringify(this.userData));
                JSON.parse(localStorage.getItem("user"));
            }
            else {
                localStorage.setItem("user", null);
                JSON.parse(localStorage.getItem("user"));
            }
        });
    }
    // sign in function
    SignIn(email, password) {
        return this.afAuth.auth.signInWithEmailAndPassword(email, password)
            .then((result) => {
            if (result.user.emailVerified !== true) {
                this.SetUserData(result.user);
                this.SendVerificationMail();
                this.showLoader = true;
            }
            else {
                this.showLoader = false;
                this.ngZone.run(() => {
                    this.router.navigate(["/auth/login"]);
                });
            }
        }).catch((error) => {
            this.toster.error("You have enter Wrong Email or Password.");
        });
    }
    // main verification function
    SendVerificationMail() {
        return this.afAuth.auth.currentUser.sendEmailVerification();
    }
    // Sign in with Facebook
    signInFacebok() {
        return this.AuthLogin(new firebase_app__WEBPACK_IMPORTED_MODULE_5__["auth"].FacebookAuthProvider());
    }
    // Sign in with Twitter
    signInTwitter() {
        return this.AuthLogin(new firebase_app__WEBPACK_IMPORTED_MODULE_5__["auth"].TwitterAuthProvider());
    }
    // Sign in with Google
    GoogleAuth() {
        return this.AuthLogin(new firebase_app__WEBPACK_IMPORTED_MODULE_5__["auth"].GoogleAuthProvider());
    }
    ForgotPassword(passwordResetEmail) {
        return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail)
            .then(() => {
            window.alert("Password reset email sent, check your inbox.");
        }).catch((error) => {
            window.alert(error);
        });
    }
    // Authentication for Login
    AuthLogin(provider) {
        return this.afAuth.auth.signInWithPopup(provider)
            .then((result) => {
            this.SetUserData(result.user);
        }).catch((error) => {
            window.alert(error);
            throw error;
        });
    }
    // Set user
    SetUserData(user) {
        const userRef = this.afs.doc(`users/${user.uid}`);
        const userData = {
            email: user.email,
            displayName: user.displayName,
            uid: user.uid,
            photoURL: user.photoURL || "assets/dashboeard/boy-2.png",
            emailVerified: user.emailVerified,
        };
        userRef.delete()
            .then(() => {
        })
            .catch((err) => {
        });
        return userRef.set(userData, {
            merge: true,
        });
    }
    // Sign out
    SignOut() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };
        return this.afAuth.auth.signOut().then(() => {
            this.showLoader = false;
            localStorage.clear();
            this.cookieService.deleteAll("user", "/auth/login");
            this.router.navigate(["/auth/login"]);
        });
    }
    get isLoggedIn() {
        const user = JSON.parse(localStorage.getItem("user"));
        return (user != null && user.emailVerified !== false) ? true : false;
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_3__["AngularFirestore"] },
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__["AngularFireAuth"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_7__["ToastrService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__["CookieService"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], AuthService);



/***/ }),

/***/ "./src/app/services/auth/index.ts":
/*!****************************************!*\
  !*** ./src/app/services/auth/index.ts ***!
  \****************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _auth_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./auth.service */ "./src/app/services/auth/auth.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return _auth_service__WEBPACK_IMPORTED_MODULE_1__["AuthService"]; });





/***/ }),

/***/ "./src/app/services/index.ts":
/*!***********************************!*\
  !*** ./src/app/services/index.ts ***!
  \***********************************/
/*! exports provided: SERVICES, SchoolsService, AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SERVICES", function() { return SERVICES; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./auth */ "./src/app/services/auth/index.ts");
/* harmony import */ var _schools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./schools */ "./src/app/services/schools/index.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolsService", function() { return _schools__WEBPACK_IMPORTED_MODULE_2__["SchoolsService"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return _auth__WEBPACK_IMPORTED_MODULE_1__["AuthService"]; });






const SERVICES = [
    _schools__WEBPACK_IMPORTED_MODULE_2__["SchoolsService"],
    _auth__WEBPACK_IMPORTED_MODULE_1__["AuthService"],
];


/***/ }),

/***/ "./src/app/services/schools/dummy-data.ts":
/*!************************************************!*\
  !*** ./src/app/services/schools/dummy-data.ts ***!
  \************************************************/
/*! exports provided: ComptonSchool, Schools */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComptonSchool", function() { return ComptonSchool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Schools", function() { return Schools; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

//#region Test Video Sets
const testVideosSet1 = [
    { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];
const testVideosSet2 = [
    { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 2, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 6, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];
const testVideosSet3 = [
    { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 2, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 3, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 4, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 5, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
    { id: 6, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];
//#endregion Test Video Sets
//#region Compton school
const ComptonSchool = {
    id: 1,
    name: "Compton",
    description: "Some long text description here. Maybe html...",
    defaultCourseId: 73,
    courses: [
        {
            id: 10001,
            name: "Math 10A",
            units: 2,
            part: "I",
            additionalInfo: "Basic Arithmetic Skills",
        },
        {
            id: 10002,
            name: "Math 10B",
            units: 2,
            part: "II",
            additionalInfo: "Basic Arithmetic Skills",
        },
        {
            id: 12,
            name: "Math 12",
            units: 4,
            additionalInfo: "Basic Arithmetic Skills",
        },
        {
            id: 25,
            name: "Math 25",
            units: 2,
            additionalInfo: "Pre-Algebra Review",
        },
        {
            id: 23,
            name: "Math 23",
            units: 2,
            additionalInfo: "Pre Algebra",
            videos: testVideosSet2
        },
        {
            id: 40,
            name: "Math 40",
            units: 4,
            additionalInfo: "Elementary Algebra",
            videos: testVideosSet2
        },
        {
            id: 33,
            name: "Math 33",
            units: 3,
            part: "I",
            additionalInfo: "Extended Elementary Algebra",
        },
        {
            id: 43,
            name: "Math 43",
            units: 3,
            part: "II",
            additionalInfo: "Extender Elementary Algebra",
        },
        {
            id: 80,
            name: "Math 80",
            units: 5,
            additionalInfo: "Intermediate Algebra for STEM"
        },
        {
            id: 73,
            name: "Math 73",
            units: 5,
            additionalInfo: "Intermediate Algebra for General Education",
            videos: []
        },
        {
            id: 60,
            name: "Math 60",
            units: 4,
            additionalInfo: "Elementary Geometry",
            videos: testVideosSet3
        },
        {
            id: 170,
            name: "Math 170 *",
            units: 3,
            additionalInfo: "Trigonometry"
        },
        {
            id: 180,
            name: "Math 180 *",
            units: 5,
            additionalInfo: "Pre-Calculus",
        },
        {
            id: 130,
            name: "Math 130 **",
            units: 3,
            additionalInfo: "College Algebra",
        },
        {
            id: 120,
            name: "Math 120 *",
            units: 3,
            additionalInfo: "Nature of Math"
        },
        {
            id: 140,
            name: "Math 140 **",
            units: 4,
            additionalInfo: "Finite Math"
        },
        {
            id: 150,
            name: "Math 150 **",
            units: 4,
            additionalInfo: "Elementary Probability and Statistics",
            videos: testVideosSet3
        },
        {
            id: 160,
            name: "Math 160 **",
            units: 4,
            additionalInfo: "Calculus for the Biological, Management, and Social Sciences I",
        },
        {
            id: 161,
            name: "Math 161 **",
            units: 4,
            additionalInfo: "Calculus for the Biological, Management, and Social Sciences II",
            videos: testVideosSet1
        },
        {
            id: 190,
            name: "Math 190 **",
            units: 5,
            additionalInfo: "Single Variable Calculus I",
        },
        {
            id: 191,
            name: "Math 191 **",
            units: 4,
            additionalInfo: "Single Variable Calculus II",
        },
        {
            id: 220,
            name: "Math 220 **",
            units: 4,
            additionalInfo: "Multi-Variable Calculus",
        }
    ],
    coursesLinks: [
        { parentId: 10001, childId: 10002 },
        { parentId: 10002, childId: 23 },
        { parentId: 10002, childId: 25 },
        { parentId: 12, childId: 23 },
        { parentId: 12, childId: 25 },
        { parentId: 25, childId: 40 },
        { parentId: 25, childId: 33 },
        { parentId: 23, childId: 40 },
        { parentId: 23, childId: 33 },
        { parentId: 40, childId: 73 },
        { parentId: 33, childId: 43 },
        { parentId: 43, childId: 80 },
        { parentId: 43, childId: 73 },
        { parentId: 43, childId: 60 },
        { parentId: 80, childId: 170 },
        { parentId: 80, childId: 120 },
        { parentId: 80, childId: 140 },
        { parentId: 80, childId: 130 },
        { parentId: 80, childId: 150 },
        { parentId: 73, childId: 150 },
        { parentId: 73, childId: 120 },
        { parentId: 73, childId: 140 },
        { parentId: 73, childId: 130 },
        { parentId: 73, childId: 150 },
        { parentId: 170, childId: 180 },
        { parentId: 130, childId: 160 },
        { parentId: 180, childId: 160 },
        { parentId: 180, childId: 190 },
        { parentId: 160, childId: 161 },
        { parentId: 190, childId: 191 },
        { parentId: 191, childId: 220 },
    ],
};
//#endregion Compton school
const Schools = [ComptonSchool];


/***/ }),

/***/ "./src/app/services/schools/index.ts":
/*!*******************************************!*\
  !*** ./src/app/services/schools/index.ts ***!
  \*******************************************/
/*! exports provided: SchoolsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _schools_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./schools.service */ "./src/app/services/schools/schools.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchoolsService", function() { return _schools_service__WEBPACK_IMPORTED_MODULE_1__["SchoolsService"]; });





/***/ }),

/***/ "./src/app/services/schools/schools.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/services/schools/schools.service.ts ***!
  \*****************************************************/
/*! exports provided: SchoolsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchoolsService", function() { return SchoolsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/firestore */ "./node_modules/@angular/fire/firestore/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _dummy_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dummy-data */ "./src/app/services/schools/dummy-data.ts");





let SchoolsService = class SchoolsService {
    constructor(db) {
        this.db = db;
        this.colName = "schools";
    }
    getAll() {
        // return from([[ComptonSchool]]);
        return this.db.collection(this.colName).snapshotChanges()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((actions) => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })));
    }
    create(value) {
        return this.db.collection(this.colName).add(value);
    }
    update(key, value) {
        return this.db.collection(this.colName).doc(key).set(value);
    }
    createTestSchool() {
        const compton = _dummy_data__WEBPACK_IMPORTED_MODULE_4__["ComptonSchool"];
        return this.create(compton);
    }
};
SchoolsService.ctorParameters = () => [
    { type: _angular_fire_firestore__WEBPACK_IMPORTED_MODULE_2__["AngularFirestore"] }
];
SchoolsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], SchoolsService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyBWPwTuGXzwchNUtg5PFuurZwpwg910h60",
        authDomain: "school-charts.firebaseapp.com",
        databaseURL: "https://school-charts.firebaseio.com",
        projectId: "school-charts",
        storageBucket: "school-charts.appspot.com",
        messagingSenderId: "401304359698",
        appId: "1:401304359698:web:d29a1884a52bcfced999cb",
    },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch((err) => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! D:\Projects\math-charts\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map